import { configureStore } from "@reduxjs/toolkit";

import authenticationReducer from "./slices/authentication";


// ...

export const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
  },
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false,
  }),
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
